module.exports = __webpack_public_path__ + "static/media/logo-grey.c46aac78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/NavBar/icons/logo-grey.svg
// module id = 1670
// module chunks = 0